(function () {
  'use strict';

  // Keep the existing cart requests and rendering; synchronize the drawer's UI state.
  if (window.erpMobileEnhancementLoaded) return;
  window.erpMobileEnhancementLoaded = true;
  var script = document.currentScript;
  var labels = {
    decrease: script && script.dataset.cartDecrease || 'Decrease quantity',
    increase: script && script.dataset.cartIncrease || 'Increase quantity'
  };
  var controllers = new Map();
  var pendingOpener = null;
  var focusSelector = 'a[href],button,input,select,textarea,summary,[tabindex]';

  function focus(element, preserveScroll) {
    if (!element || !element.isConnected) return;
    try { element.focus({ preventScroll: preserveScroll === true }); }
    catch (error) { element.focus(); }
  }

  function available(element) {
    return !element.disabled && element.tabIndex >= 0 &&
      !element.closest('[inert],[hidden],[aria-hidden="true"]') &&
      element.getClientRects().length > 0 &&
      getComputedStyle(element).visibility !== 'hidden';
  }

  function closeMenu() {
    var menu = document.querySelector('[data-nav-mobile].is-open');
    if (!menu) return;
    var toggle = document.querySelector('[data-nav-toggle]');
    if (toggle) toggle.click();
  }

  function backgroundOutside(drawer) {
    var state = [];
    var branch = drawer;
    while (branch && branch.parentElement) {
      Array.from(branch.parentElement.children).forEach(function (sibling) {
        if (sibling === branch || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
        state.push([sibling, sibling.inert]);
        sibling.inert = true;
      });
      if (branch.parentElement === document.body) break;
      branch = branch.parentElement;
    }
    return state;
  }

  function bind(drawer) {
    if (controllers.has(drawer)) return;
    var panel = drawer.querySelector('.cart-drawer__panel');
    if (!panel) return;
    var open = false;
    var opener = null;
    var background = [];
    if (!panel.hasAttribute('tabindex')) panel.tabIndex = -1;

    function labelQuantityButtons() {
      drawer.querySelectorAll('[data-cart-minus]:not([aria-label]):not([aria-labelledby])')
        .forEach(function (button) { button.setAttribute('aria-label', labels.decrease); });
      drawer.querySelectorAll('[data-cart-plus]:not([aria-label]):not([aria-labelledby])')
        .forEach(function (button) { button.setAttribute('aria-label', labels.increase); });
    }

    function firstControl() {
      return Array.from(panel.querySelectorAll(focusSelector)).find(available) || panel;
    }

    function setState() {
      var next = drawer.classList.contains('is-open') && drawer.isConnected;
      if (next === open) return;
      open = next;
      if (open) {
        var active = document.activeElement;
        opener = active && active !== document.body && !drawer.contains(active) ? active : pendingOpener;
        closeMenu();
        drawer.inert = false;
        drawer.setAttribute('aria-hidden', 'false');
        panel.setAttribute('aria-modal', 'true');
        background = backgroundOutside(drawer);
        document.documentElement.classList.add('erp-cart-modal-open');
        focus(firstControl());
      } else {
        background.forEach(function (entry) { entry[0].inert = entry[1]; });
        background = [];
        document.documentElement.classList.remove('erp-cart-modal-open');
        // Move focus out before hiding the drawer from accessibility APIs.
        if (drawer.contains(document.activeElement)) focus(opener, true);
        panel.removeAttribute('aria-modal');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.inert = true;
        opener = null;
      }
    }

    function close() {
      drawer.classList.remove('is-open');
      setState();
    }

    function onKey(event) {
      if (!open) return;
      // A native dialog uses the browser's top layer and owns its own focus.
      if (document.querySelector('dialog[open]')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      } else if (event.key === 'Tab') {
        var controls = Array.from(panel.querySelectorAll(focusSelector)).filter(available);
        var first = controls[0];
        var last = controls[controls.length - 1];
        var active = document.activeElement;
        if (!first) { event.preventDefault(); focus(panel); }
        else if (event.shiftKey && (active === first || active === panel || !panel.contains(active))) {
          event.preventDefault(); focus(last);
        } else if (!event.shiftKey && (active === last || !panel.contains(active))) {
          event.preventDefault(); focus(first);
        }
      }
    }

    var stateObserver = new MutationObserver(setState);
    stateObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    var contentObserver = new MutationObserver(labelQuantityButtons);
    contentObserver.observe(panel, { childList: true, subtree: true });
    labelQuantityButtons();
    drawer.inert = true;
    drawer.setAttribute('aria-hidden', 'true');
    panel.removeAttribute('aria-modal');
    controllers.set(drawer, {
      drawer: drawer,
      panel: panel,
      isOpen: function () { return open; },
      firstControl: firstControl,
      onKey: onKey,
      destroy: function () { close(); stateObserver.disconnect(); contentObserver.disconnect(); }
    });
    setState();
  }

  function init() {
    controllers.forEach(function (controller, drawer) {
      if (!drawer.isConnected) { controller.destroy(); controllers.delete(drawer); }
    });
    document.querySelectorAll('[data-cart-drawer]').forEach(bind);
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var trigger = event.target.closest('[data-cart-open],button[type="submit"],button[name="add"]');
    if (trigger && (trigger.matches('[data-cart-open]') || trigger.closest('form[action*="/cart/add"]'))) {
      pendingOpener = trigger;
    }
  }, true);
  document.addEventListener('keydown', function (event) {
    controllers.forEach(function (controller) { controller.onKey(event); });
  });
  document.addEventListener('focusin', function (event) {
    if (document.querySelector('dialog[open]')) return;
    controllers.forEach(function (controller) {
      if (controller.isOpen() && !controller.panel.contains(event.target)) focus(controller.firstControl());
    });
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (controller, drawer) {
      if (event.target.contains(drawer)) { controller.destroy(); controllers.delete(drawer); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
